import { UserComponent } from './user.component';
import userAbbrFilter from './utils/user-abbr.filter';

export default angular
  .module('sfMobile.components.user', ['sfMobile.components.avatar-user'])
  .filter('sfUserAbbr', userAbbrFilter)
  .component('sfUser', UserComponent).name;
